<template>
    <DxDataGridZonas :dxDataSourceProp="dxDataGridSource" />
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import type CustomStore from 'devextreme/data/custom_store';
import DxDataGridZonas from "./DxDataGridZonas.vue";

const props = defineProps<{ dxDataSourceProp: CustomStore | undefined }>();
const dxDataGridSource = computed(() => props.dxDataSourceProp);
</script>